import { mergeSx } from "@/utils/styleHelpers";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";
import { SvgIcon } from "../SvgIcon";

export function WalletConnectSymbol({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("WalletConnectSymbol");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 48 48"
      sx={mergeSx({ fill: "#368AFA", w: "100px" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}
